/*
 * Global Layout and Etc.
 */
export const GLOBAL_STYLE = {
  contentMaxWidth: '1520px',

  // Together 50px navbar height
  navbarDebugHeight: '6px',
  navbarBodyHeight: '44px',
  navbarMaxHeight: '64px',  // XXX: Not used.. delete
};

export const DOCK_TRANSITION_DURATION = 200  // ms


/*
 * Exposed portal roots
 */
// App level
export const OVERLAY_PORTAL_ROOT_ID = 'app-overlay-portal-root';
export const MASKING_PORTAL_ROOT_ID = 'app-masking-portal-root';

// Navbar level
export const NAVBAR_PORTAL_ROOT_ID = 'navbar-portal-root';


/*
 * Overlay
 */
export const OVERLAY_TYPE_START_MENU = 'OVERLAY_TYPE_START_MENU';
export const OVERLAY_TYPE_COMPOSE_EDITOR = 'OVERLAY_TYPE_COMPOSE_EDITOR';

export const OVERLAY_DISPLAY_ATTR = {
  SUSPEND_NAV_OUT: 'SUSPEND_NAV_OUT',  // Maybe suppress any links out of overlay
  SUSPEND_EXIT_WITH_SPINNER: 'SUSPEND_EXIT_WITH_SPINNER',  // Maybe suppress any links out of overlay
};


/*
 * Compose Editor
 */
export const EXPORT_PREVIEW_SIZE_REF = 16 * 28;  // 28rem

// XXX: Not used, delete..
// export const EXPORT_PREVIEW_SIZE_TINY = 16 * 3;
// export const EXPORT_PREVIEW_SIZE_MEDIUM = 16 * 20;

export const IPHONE_X_LOGICAL_WIDTH = 375;  // px

export const EXPORT_PREVIEW_ROOT_ID = 'content-export-preview-root';


/*
 * Navbar
 */
// These attributes can be set dynamically by
// components dispatching actions to redux.
export const NAVBAR_DYNAMIC_DISPLAY_ATTR = {
  OPAQUE_NAVBAR_BG: 'OPAQUE_NAVBAR_BG',
};

// These are defined per route, and remain static.
export const NAVBAR_DEFINED_DISPLAY_ATTR = {
  SHOW_CONTROL_GROUP: 'SHOW_CONTROL_GROUP',
};


/*
 * Start Menu
 */
export const START_MENU_DISPLAY_CONTEXT_LOGIN = 'START_MENU_DISPLAY_CONTEXT_LOGIN';
export const START_MENU_DISPLAY_CONTEXT_SIGNUP = 'START_MENU_DISPLAY_CONTEXT_SIGNUP';
export const START_MENU_DISPLAY_CONTEXT_RECOVER = 'START_MENU_DISPLAY_CONTEXT_RECOVER';


/*
 * Welcome Page Sequence
 */
export const WELCOME_INTRO_ACCOUNT_TYPE = 'WELCOME_INTRO_ACCOUNT_TYPE';
export const WELCOME_INIT_USER_PROFILE = 'WELCOME_INIT_USER_PROFILE';


/*
 * localStorage
 */
export const LOC_STORAGE_JWT_KEY = 'moagraph-jwt';
export const LOC_STORAGE_OAUTH_KEY = 'moagraph-oauth';
export const LOC_STORAGE_APP_STATE_KEY = 'moagraph-state';



// WEBPACK FOOTER //
// ./src/shared/constants/web/index.js